const Industries = () => {
  const industries = [
    {
      title: 'Healthcare & Life Sciences',
      description: 'Pharmaceuticals, BioPharma, Consumer Healthcare, Hospitals, Med Tech',
    },
    {
      title: 'Consumer & Retail',
      description: 'CPG, Food & Beverage, Personal Care, eCommerce, Apparel',
    },
    {
      title: 'Industrials & Resources',
      description: 'Aerospace, Automotive, Machinery, Chemicals, Agriculture, Mining',
    },
    {
      title: 'Energy & Utilities',
      description: 'Oil & Gas, Power, Renewables, Natural Resources',
    },
    {
      title: 'Technology, Media & Telecom',
      description: 'SaaS, Platforms, Enterprise Tech, Telecom, Media',
    },
    {
      title: 'Financial Services',
      description: 'Banking, Insurance, Private Equity, Asset Management',
    },
  ]

  const impactAreas = [
    'Procurement & Supply Chain',
    'Commercial & Customer Growth',
    'Financial & Decision Intelligence',
  ]

  return (
    <section 
      id="industries" 
      className="py-24 bg-gray-50 relative overflow-hidden scroll-mt-20"
      style={{
        backgroundImage: 'url(/assets/industries-background.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="mb-12">
          <h2 className="text-sm font-bold tracking-widest text-blue-600 uppercase mb-3">
            Our Expertise
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900">Industries We Serve</h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry, idx) => (
            <div
              key={idx}
              className="p-6 bg-white border-2 border-gray-300 rounded-xl shadow-md hover:shadow-lg hover:border-gray-400 hover:bg-gray-50 transition-all"
            >
              <h4 className="font-bold text-lg mb-2 text-gray-900">{industry.title}</h4>
              <p className="text-sm text-gray-800">{industry.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-16 border-t border-gray-200">
          <h3 className="text-2xl font-bold mb-6 text-center">Where We Create Impact</h3>
          <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-12 text-center md:text-left">
            {impactAreas.map((area, idx) => (
              <div key={idx} className="flex items-center justify-center md:justify-start">
                <i className="fa-solid fa-check-circle text-blue-500 mr-3"></i>
                <span className="text-lg font-medium text-gray-800">{area}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Industries
